import { useRootStore } from 'stores/RootStore'
import { SharedStyle } from '@tldraw/tldraw'
import { FontWeightType } from '../Types'
import { CustomFont } from 'stores/CustomFonts/CustomFont'

export const useAvailableWeights = (
  fontFamilyStyle: SharedStyle<string>,
  italicStyle: SharedStyle<boolean>,
): FontWeightType[] => {
  const { fonts } = useRootStore()

  if (fontFamilyStyle.type === 'mixed' || italicStyle.type === 'mixed') {
    return [400]
  }

  const font = fonts.get(fontFamilyStyle.value)

  if (!font) {
    return [400]
  }

  if (font instanceof CustomFont) {
    return [font.weight]
  }

  if (italicStyle.value) {
    return font.italicWeights
  }

  return font.weights
}
